import { theme } from 'lib/theme';
import React from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import { ViewWithSeparators } from './ViewWithSeparators';

interface Props {
  margin?: boolean;
  marginTop?: boolean;
  style?: StyleProp<ViewStyle>;
  children: React.ReactNode;
}

export const CardGeneric: React.FC<Props> = ({
  children,
  margin = true,
  marginTop = false,
  style,
}) => (
  <View
    style={[
      styles.view,
      margin ? styles.viewWithMarginBottom : undefined,
      marginTop ? styles.viewWithMarginTop : undefined,
      style,
    ]}
  >
    <ViewWithSeparators
      separator={<View style={{ height: theme.paddingHorizontal }} />}
    >
      {children}
    </ViewWithSeparators>
  </View>
);

const styles = StyleSheet.create({
  view: {
    borderRadius: 8,
    overflow: 'hidden',
    paddingHorizontal: theme.paddingHorizontal * 2,
  },
  viewWithMarginBottom: {
    marginBottom: theme.paddingVertical / 2,
  },
  viewWithMarginTop: {
    marginTop: theme.paddingVertical / 2,
  },
});
